(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rhino-client-logos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rhino-logo-scroll')) {
  customElements.define('rhino-logo-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.stop) return;
      const row = this.querySelector('.rhino-clients__row');
      const button = this.querySelector('.rhino-clients__toggle');
      if (!row || !button || !row.children.length) return;
      const controller = new AbortController();
      const options = {signal: controller.signal};
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const originals = [...row.children];
      const clones = originals.map(item => {
        const copy = item.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block');
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a').forEach(a => a.tabIndex = -1);
        row.append(copy);
        return copy;
      });
      let paused = false, hovering = false, interacting = false, last = 0, position = row.scrollLeft, frame;
      button.hidden = false;
      const updateButton = () => {
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? this.dataset.resume : this.dataset.pause;
      };
      button.addEventListener('click', () => { paused = !paused; updateButton(); }, options);
      row.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovering = true; }, options);
      row.addEventListener('pointerleave', () => { hovering = false; }, options);
      row.addEventListener('pointerdown', () => { interacting = true; }, options);
      window.addEventListener('pointerup', () => { interacting = false; position = row.scrollLeft; }, options);
      window.addEventListener('pointercancel', () => { interacting = false; }, options);
      row.addEventListener('wheel', () => { paused = true; updateButton(); }, {...options, passive:true});
      const applyMotion = () => { clones.forEach(c => c.hidden = motion.matches); button.hidden = motion.matches; };
      motion.addEventListener('change', applyMotion, options);
      applyMotion();
      const tick = time => {
        const delta = last ? Math.min(time - last, 50) : 0;
        last = time;
        const focused = row.contains(document.activeElement);
        if (!paused && !hovering && !interacting && !focused && !motion.matches && !document.hidden) {
          const distance = clones[0].offsetLeft - originals[0].offsetLeft;
          if (distance > 0 && row.scrollWidth > row.clientWidth) {
            position = (position + delta * 0.0246402) % distance;
            row.scrollLeft = position;
          }
        } else position = row.scrollLeft;
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
      this.stop = () => { cancelAnimationFrame(frame); controller.abort(); clones.forEach(c => c.remove()); };
    }
    disconnectedCallback() { if (this.stop) this.stop(); this.stop = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhino-gift-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input',(event)=>{
const root=event.target.closest('[data-rhino-gifts]');if(!root)return;
const amount=root.querySelector('[data-gift-amount]');const quantity=root.querySelector('[data-gift-quantity]');const total=root.querySelector('[data-gift-total]');
if(!amount||!quantity||!total)return;
if(!quantity.validity.valid||quantity.value===''){total.textContent='—';return;}
total.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(Number(amount.selectedOptions[0].dataset.price)/100*Number(quantity.value));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhino-project-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rhino-project-gallery')) {
  customElements.define('rhino-project-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-gallery-photo]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        const image = dialog.querySelector('[data-gallery-large]');
        image.src = link.href;
        image.alt = link.dataset.caption;
        dialog.querySelector('[data-gallery-caption]').textContent = link.dataset.caption;
        dialog.showModal();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
